import { ExportSheet } from '../core';
import { DataPreparer } from '../factory';

export class ListagemAquisicoesExportPreparer implements DataPreparer {
  async prepareForExport(selectedItems: any[]): Promise<ExportSheet[]> {
    const mainSheetData = selectedItems.map((item) => {
      return {
        id: item.id,
        tipo: item.tipo,
        componenteAf: item.componenteAf,
        status: item.status,
        numero: item.numero,
        fornecedor: item.fornecedor,
        fornecedorCnpj: item.fornecedorCnpj,
        produtos: item.produtos,
      };
    });

    const mainSheet: ExportSheet = {
      name: 'Listagem de Aquisições',
      columns: {
        id: 'ID',
        tipo: 'Tipo',
        componenteAf: 'Componente AF',
        status: 'Status',
        numero: 'Número',
        fornecedor: 'Fornecedor',
        fornecedorCnpj: 'CNPJ Fornecedor',
        produtos: 'Produtos',
      },
      data: mainSheetData,
    };

    return [mainSheet];
  }
}
